module.exports = __webpack_public_path__ + "static/media/portfolio4.86f831d8.png";